export default (variants, selectedColourWayId) =>
  variants.filter(variant => variant.colourWayId === selectedColourWayId);
